import { useMutation } from '@tanstack/react-query';

import { PrimaryButton } from '@/components/Buttons';
import Loader from '@/components/Loader';
import ViralLoopsFormWidget from '@/components/ReferralButton/ViralLoopsFormWidget';
import { useViralLoops } from '@/components/ReferralProvider/hooks';
import { patchUserMutationFn } from '@/queries/users';
import { useSelector, useStore } from '@/redux/helper';
import { selectIsReferralParticipant } from '@/redux/selectors/users';
import { setUserData } from '@/redux/slices/user/actions';
import { buildURL, get } from '@/shared/fetch';

export default function ReferralSection() {
  const store = useStore();
  const viralLoops = useViralLoops();
  const email = useSelector((state) => state.user.email);
  const viralLoopsCampaignId = useSelector((state) => state.remoteConfig.viralLoopsCampaignId);
  const isReferralParticipant = useSelector(selectIsReferralParticipant);

  const { mutate: patchUser } = useMutation({
    mutationFn: patchUserMutationFn,
    onSuccess: () => {
      get(buildURL('/users/user'))
        .then((user) => store.dispatch(setUserData(user)))
        .catch(console.error);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  if (!email) {
    return null;
  }

  if (!viralLoops || !viralLoopsCampaignId) {
    return <Loader />;
  }

  if (isReferralParticipant) {
    return <ViralLoopsFormWidget campaignId={viralLoopsCampaignId} />;
  }

  const onClick = () => {
    viralLoops
      ?.getCampaign()
      .then((campaign) => {
        if (!campaign) {
          return undefined;
        }
        const { userId, subscription, name, username } = store.getState().user;
        const { stripeCurrency: currency } = subscription ?? {};
        return campaign?.identify({ email, firstname: name || username || undefined, extraData: { userId, currency } });
      })
      .then((viralLoopsData) => {
        if (!viralLoopsData) return;
        const { referralCode } = viralLoopsData;
        const currentUserReferralCode = store.getState().user.referralData?.viralLoops?.referralCode;
        if (currentUserReferralCode !== referralCode) {
          patchUser({ referralData: { viralLoops: { referralCode } } });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div className="mx-auto w-full max-w-[560px] px-[25px] pt-[50px]">
      <div className="flex flex-col items-center justify-center">
        <h4 className="preflight preflight-h4 w-full text-left text-[22px] font-medium">Give 20%, Get $2!</h4>
        <p className="preflight preflight-p mt-[15px] text-base">
          Share your referral link. Your friends get 20% off, and you earn $2 credit for every signup.
        </p>
      </div>
      <div className="mt-[30px] flex flex-col items-center justify-center">
        <PrimaryButton label="Join the referral program" onClick={onClick} />
      </div>
    </div>
  );
}
